import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "chart-wrapper" }
const _hoisted_3 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row align-items-end" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "form-label fw-medium text-paragraph" }
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-label fw-medium text-paragraph" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "form-label fw-medium text-paragraph" }
const _hoisted_14 = { class: "chart-wrapper" }
const _hoisted_15 = { class: "chart-wrapper style-one d-flex" }
const _hoisted_16 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_17 = { class: "card-body p-xl-40" }
const _hoisted_18 = { class: "card-title fw-semiBold fs-18 mb-30" }
const _hoisted_19 = { class: "chart-body" }
const _hoisted_20 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_21 = { class: "card-body p-xl-40" }
const _hoisted_22 = { class: "card-title fw-semiBold fs-18 mb-30" }
const _hoisted_23 = { class: "chart-wrapper style-two d-flex" }
const _hoisted_24 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_25 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_26 = { class: "chart-wrapper" }
const _hoisted_27 = { class: "card border-0 shadow-none rounded-1 mb-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_StatusContent = _resolveComponent("StatusContent")!
  const _component_TopSellingProductsChart = _resolveComponent("TopSellingProductsChart")!
  const _component_ThisWeeksSalesPurchasesChart = _resolveComponent("ThisWeeksSalesPurchasesChart")!
  const _component_StockAlert = _resolveComponent("StockAlert")!
  const _component_TopCustomerChart = _resolveComponent("TopCustomerChart")!
  const _component_RecentSales = _resolveComponent("RecentSales")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("dashboard_page.warehouse")), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select h-55",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.warehouse_id) = $event))
                }, [
                  _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t("dashboard_page.all_warehouses")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (w) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: w.id,
                      value: w.id
                    }, _toDisplayString(w.name), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.warehouse_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("dashboard_page.start_date")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control h-55",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.from_date) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.filters.from_date]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("dashboard_page.end_date")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control h-55",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.to_date) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.filters.to_date]
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_StatusContent, {
          stats: _ctx.stats,
          "is-loading": _ctx.statsLoading
        }, null, 8, ["stats", "is-loading"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h6", _hoisted_18, _toDisplayString(_ctx.$t("dashboard_page.top_selling_products")), 1),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_TopSellingProductsChart, {
                items: _ctx.topProducts,
                "is-loading": _ctx.topProductsLoading
              }, null, 8, ["items", "is-loading"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("h6", _hoisted_22, _toDisplayString(_ctx.$t("dashboard_page.monthly_sales_purchases")), 1),
            _createVNode(_component_ThisWeeksSalesPurchasesChart, {
              items: _ctx.monthlyStats,
              "is-loading": _ctx.monthlyLoading
            }, null, 8, ["items", "is-loading"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_StockAlert, {
            items: _ctx.stockAlerts,
            "is-loading": _ctx.stockAlertsLoading
          }, null, 8, ["items", "is-loading"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_TopCustomerChart, {
            items: _ctx.topCustomers,
            "is-loading": _ctx.topCustomersLoading
          }, null, 8, ["items", "is-loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_RecentSales, {
            items: _ctx.recentSales,
            "is-loading": _ctx.recentSalesLoading,
            onPaymentAdded: _ctx.refreshRecentSales
          }, null, 8, ["items", "is-loading", "onPaymentAdded"])
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}